import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';

import { useAuthRouter } from './auth.route';
import { UserRoleSelectionDialog } from './components';
import { useDashboardRouter } from './dashboard.route';
import { useDeliveryNoteRouter } from './delivery-note.route';
import { useHomeRouter } from './home.route';
import { useInboundRouter } from './inbound.route';
import { useInventoryAdjustmentRouter } from './inventory-adjustment.route';
import { usePackTaskRouter } from './pack-task.route';
import { usePickTaskRouter } from './pick-task.route';
import { usePrintTemplateRouter } from './print-template.route';
import { useReplenishRouter } from './replenish.route';
import { useSTOCheckRouter } from './sto-check.route';
import { useSTOPickRouter } from './sto-pick.route';
import { useSTOPrintTemplateRouter } from './sto-print-template.route';
import { useSTOReceiveRouter } from './sto-receive.route';
import { useStockTransferRouter } from './stock-transfer.route';

export const AppRouter = (): React.JSX.Element => (
  <>
    <Routes>
      <Route path="/" element={<Navigate to="/login" />} />
      {useAuthRouter()}
      {useHomeRouter()}
      {useReplenishRouter()}
      {usePickTaskRouter()}
      {usePackTaskRouter()}
      {useDashboardRouter()}
      {usePrintTemplateRouter()}
      {useStockTransferRouter()}
      {useInventoryAdjustmentRouter()}
      {useSTOPickRouter()}
      {useSTOCheckRouter()}
      {useSTOReceiveRouter()}
      {useSTOPrintTemplateRouter()}
      {useInboundRouter()}
      {useDeliveryNoteRouter()}
      <Route path="/not-found" element={<div>Not found</div>} />
      <Route path="/*" element={<Navigate to="/login" />} />
    </Routes>
    <UserRoleSelectionDialog />
  </>
);
